/**
 * Created by Gaurav on 18/OCT/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {BFGameEvent} from "../events/BFGameEvent";
import {BurningReelSymbol} from "./BurningReelSymbol";

export class BurningScatterReelSymbol extends BurningReelSymbol {

    private _symAnimPosX:number = 0;
    private _symAnimPosY:number = 0;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, BFGameEvent.STOP_SCATTER_FIRE_ANIM, (event:GameEvent) => this.stopFireOverlay(event.params[0], event.params[1], event.params[2], event.params[3]));
        EventHandler.addEventListener(this, BFGameEvent.STOP_SCATEER_ANIMAITON_ON_REEL, (event:GameEvent) => { this._fireOverlay && (this._fireOverlay.hide(), this._fireOverlay.stopLoop()) });

    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === GameConfig.instance.SYMBOL_STATES.spin.keyword && this.visible) {
            timeline.add(() => this.playFireOverlay(), delay);
        }
    }

    protected createSpinningFireOverlay():TimelineSprite {
        const fire:TimelineSprite = new TimelineSprite(GameResources.getTextures("scatterSpinningFire"), 16);

        fire.anchor.set(0.5, 0.5);
        fire.position.set(this._symAnimPosX, this._symAnimPosY);
        fire.scale.set(1, 1);
        return fire;
    }

    protected createLandingFireOverlay():TimelineSprite {
        const fire:TimelineSprite = new TimelineSprite(GameResources.getTextures("scatterLandingFire"), 32);

        fire.anchor.set(0.5, 0.5);
        fire.position.set(this._symAnimPosX, this._symAnimPosY);
        fire.scale.set(1, 1);
        return fire;
    }

    protected playFireSound():void {
        //SlotGame.sound.playEffect(BarbarianFuryGameConfig.instance.FLY_BY_FIRE);
    }
}